export var PlausibleEventType;
(function (PlausibleEventType) {
    PlausibleEventType["Landed"] = "Landed on tap feed";
    PlausibleEventType["OpenSingUp"] = "Open sign-up form";
    PlausibleEventType["CompletedRegistration"] = "Completed registration";
    PlausibleEventType["CompletedFirstStep"] = "Sign-up first step completed";
})(PlausibleEventType || (PlausibleEventType = {}));
export var plausibleEventHandler = function (event) {
    var _a;
    if (typeof window !== 'undefined') {
        (_a = window.plausible) === null || _a === void 0 ? void 0 : _a.call(window, event);
    }
};
